import React, { useEffect, useState } from "react";
import RiskCards from "../../cards/risk-cards";
import Select from "react-select";
import { useSelector } from "react-redux";
import Typography from "../../common/Typography";
import { useTheme } from "@mui/material";

const Cards = ({
  filterIssues,
  selectedAccount,
  setSelectedAccount,
  inputText,
  setInputText,
  identities,
}) => {
  const [accountList, setAccountList] = useState([
    { value: "all", label: "All" },
  ]);
  const theme = useTheme();
  const accounts = useSelector((state) => state.account.accounts);

  const styles = {
    breadcrumb: {
      padding: theme.spacing(2),
      paddingTop: 0,
    },
  };

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      setAccountList([
        { value: "all", label: "All" },
        ...accounts.map((account) => {
          return { value: account.id, label: account.id };
        }),
      ]);
    }
  }, [accounts]);
  return (
    <div>
      <div className="row align-items-center">
        <Typography
          color={theme.palette.surface100.main}
          variant="body2"
          sx={styles.breadcrumb}
        >
          {"USERS > "}
          <span className="text-info">{"USERS OVERVIEW"}</span>
        </Typography>
        <div className="col-12 col-md-12 col-xl-8 mb-2">
          <div className="row justify-content-xl-end">
            <div className="col-auto">
              <b className="page-heading align-middle fs-14">
                ACCOUNT FILTER :
              </b>
            </div>
            <div className="col-auto">
              <Select
                options={accountList}
                classNamePrefix="accounts-dropdown"
                placeholder="Select Account"
                defaultValue={accountList.length > 0 && accountList[0]}
                value={
                  accountList.find(
                    (element) => element.value === selectedAccount.value
                  )
                    ? selectedAccount
                    : accountList[0]
                }
                onChange={(value) => setSelectedAccount(value)}
                isSearchable={false}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-10">
          <RiskCards
            filterIssues={filterIssues}
            accountId={selectedAccount ? selectedAccount.value : undefined}
            identities={identities}
          />
        </div>
      </div>
    </div>
  );
};

export default Cards;
